// Unlike every other shim (add_days -> addDays, etc.), the v1 alias key and the v3
// submodule name are both spelled 'format'. webpack's v1 alias and Jest's
// moduleNameMapper both intercept the literal specifier 'date-fns/format' and redirect
// it back to this file, so requiring it here would self-reference and loop
// (`format` would resolve to this file's own, still-empty module.exports).
// Reach into node_modules directly to get the real v3 module instead.
const { format } = require('../../../node_modules/date-fns/format');

// @sparefoot/react-core passes date-fns v1 (Moment-style) tokens: YYYY/YY (year)
// and DD/D (day of month). In date-fns v3 uppercase Y is *week-year* and uppercase D
// is *day-of-year*, so the old "enable additional tokens" approach silently produced
// wrong dates (e.g. 'MM/DD/YYYY' -> '07/197/2026' instead of '07/16/2026'). Translate
// the legacy tokens to their v3 equivalents (Y->y, D->d) instead.
//
// ponytail: Y->y, D->d, and ddd(d)->EEE(E) are handled — those are the v1 tokens
// react-core actually uses (YYMD, MM/DD/YYYY, MMMM YYYY) plus the weekday tokens,
// which are all valid-but-wrong in v3 (lowercase d is day-of-month there, so
// 'dddd' silently renders as a zero-padded day-of-month like '0016', not a throw).
// Add more tokens to the map here if a caller needs them.
function toV3Tokens(formatStr) {
	// Only translate outside single-quoted literal segments (date-fns escape syntax).
	return formatStr.replace(/'[^']*'|[YD]+|d+/g, (match) => {
		if (match.startsWith("'")) return match;
		if (match[0] === 'd') {
			if (match.length === 4) return 'EEEE';
			if (match.length === 3) return 'EEE';
			return match;
		}
		return match.replace(/Y/g, 'y').replace(/D/g, 'd');
	});
}

module.exports = function formatLegacy(date, formatStr, options) {
	return format(date, toV3Tokens(formatStr), options);
};
